module.exports = __webpack_public_path__ + "static/media/CICLO_2_GENERO_DIGITAL_2022.0e12e6a0.jpg";